import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

interface TableHeaderProps {
  globalFilterValue: string;
  onGlobalFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  buttonText?: string;
  onButtonClick?: () => void;
}

const TableHeader: React.FC<TableHeaderProps> = ({
  globalFilterValue,
  onGlobalFilterChange,
  buttonText,
  onButtonClick,
}) => {
  return (
    <div className="table-header">
      <div className="left-content">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText 
            value={globalFilterValue} 
            onChange={onGlobalFilterChange} 
            placeholder="Buscar en todos los campos" 
          />
        </span>
      </div>
      {buttonText && onButtonClick && (
        <div className="right-content">
          <Button 
            label={buttonText}
            icon="pi pi-plus"
            className="p-button-text"
            onClick={onButtonClick}
          />
        </div>
      )}
    </div>
  );
};

export default TableHeader;